import RootState from 'typings/RootState'
import { createSelector } from 'reselect'
import { ConstructRoadReport, SelectedPin } from './types'
import { Event } from '../../types/event'

export const selectReport = (state: RootState): ConstructRoadReport =>
  state.reportConstructRoad.report

export const selectEvent = (state: RootState): Event =>
  state.reportConstructRoad.event

export const selectEventChecklist = (state: RootState): Event =>
  state.reportConstructRoad.eventChecklist

export const selectDefect = (state: RootState) =>
  state.reportConstructRoad.defect

export const selectCheckListQC = (state: RootState) =>
  state.reportConstructRoad.checkListQC

export const selectPinList = (state: RootState) =>
  state.reportConstructRoad.pinSelected
